import React from 'react';

import { Check } from './Check';
import { DirectDeposit } from './DirectDeposit';
import { AddReimbursementMethod } from './AddReimbursementMethod';

import { REIMBURSEMENT_METHODS } from '../../../constants';
import { CareCreditMethodCard } from './CareCreditMethodCard';

export const ReimbursementMethodCard = ({
  addressCheck = '',
  careCredit = null,
  isRedirectAvailable = false,
  lastNumbers = '',
  marketChannelId = 0,
  methodType = '',
  onReimbursementMethod = () => { },
}) => {
  const isCheck = methodType === REIMBURSEMENT_METHODS.check;

  if (careCredit?.Type === REIMBURSEMENT_METHODS.careCredit) {
    return (
      <CareCreditMethodCard
        addressCheck={addressCheck}
        careCredit
        careCreditAccount={careCredit?.LastFourDigits}
        isCheck={isCheck}
        lastNumbers={lastNumbers}
      />
    );
  }

  if (isCheck) {
    return (
      <Check
        addressCheck={addressCheck}
        isRedirectAvailable={isRedirectAvailable}
        marketChannelId={marketChannelId}
        onReimbursementMethod={onReimbursementMethod}
      />
    );
  }

  if (methodType === REIMBURSEMENT_METHODS.deposit) {
    return <DirectDeposit lastNumbers={lastNumbers} />;
  }

  // no reimbursement method set yet
  return (
    <AddReimbursementMethod
      isRedirectAvailable={isRedirectAvailable}
      marketChannelId={marketChannelId}
      onReimbursementMethod={onReimbursementMethod}
    />
  );
};
